import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GlobalService } from '../global/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class CourseService {
  private sharedDataSubject = new Subject<any>();
  sharedData$ = this.sharedDataSubject.asObservable();
  // -===================================
  private url = GlobalService.serverURL;
  private courseUrl = GlobalService.serverURL + 'course_new/';
  //url for individual courses
  private courseUrlInd = GlobalService.serverURL + 'course/';
  // =====================================
  constructor(private http: HttpClient) { }

  updateSharedData(data: any): void {
    this.sharedDataSubject.next(data);
  }
  getCourseList() {
    return this.http.get(this.courseUrl + 'create_course/get_builder_list', { headers })
  }
  courseDashboard(data){
    return this.http.post(this.courseUrl + 'create_course/get_all_course_common', data, { headers })
  }
  courseList(data) {
    return this.http.post(this.courseUrl + 'create_course/get_all_course', data, { headers })
  }
  saveCourse(data: any) {
    return this.http.post(this.courseUrl + 'create_course', data, { headers })
  }
  saveTemplateCourse(data: any) {
    return this.http.post(this.courseUrl + 'template_course', data, { headers })
  }
  getAllTemplate() {
    return this.http.post(this.courseUrl + 'template_course/get_all_template', {}, { headers })
  }
  editTemplate(data: any) {
    return this.http.post(this.courseUrl + 'template_course/edit_template', data, { headers })
  }
  getTemplateSection(data) {
    return this.http.post(this.courseUrl + 'template_course/get_template_section', data, { headers })
  }
  deleteTemplate(data) {
    return this.http.post(this.courseUrl + 'template_course/delete_template', data, { headers })
  }
  editCourse(data: any) {
    return this.http.post(this.courseUrl + 'create_course/edit_course', data, { headers })
  }
  getCourseInfo(data) {
    return this.http.post(this.courseUrl + 'create_course/course_info', data, { headers })
  }
  viewCourse(data: any) {
    // return this.http.get(this.courseUrl + 'create_course/course_info?course_id='+id+'&login_type='+login_type,  { headers })
    return this.http.post(this.courseUrl + 'create_course/get_course_wise_data', data, { headers })
  }
  onViewCourseCSV(data: any) {
    return this.http.post(this.url + 'company/export_csv/course_view_export', data, { headers })
  }
  deleteCourse(data: any) {
    return this.http.post(this.courseUrl + 'create_course/delete_course', data, { headers })
  }
  addExam(data: any) {
    return this.http.post(this.courseUrl + 'create_course/add_exam', data, { headers })
  }
  editExam(data: any) {
    return this.http.post(this.courseUrl + 'create_course/edit_exam', data, { headers })
  }
  viewExam(data) {
    return this.http.post(this.courseUrl + 'create_course/get_exam_detail', data, { headers })
  }
  deleteExam(data: any) {
    return this.http.post(this.courseUrl + 'create_course/delete_course', data, { headers })
  }
  getDepartmentList() {
    return this.http.get(this.url + 'course_builder/department', { headers })
  }
  uploadFile(data: any) {
    return this.http.post(this.courseUrl + 'create_course/upload_file_section', data, { headers })
  }
  assignCourse(data: any) {
    return this.http.post(this.courseUrl + 'create_course/assign_course', data, { headers: headers })
  }
  assignCourseEmployee(data) {
    return this.http.post(this.url + 'employee/team/assign_course', data, { headers });
  }
  changePracticalCourse() {

  }
  encrypt() {
    return this.http.get(this.courseUrl + 'create_course/encrypt', { headers })
  }
  sectionDetails = (sectionId, purchase_id): any => {
    return this.http.get(this.url + 'course/section_details?section_id=' + sectionId + '&purchase_id=' + purchase_id, { headers })
  }
  // VIEW COURSE IN WEB
  getCourseDetail(data) {
    return this.http.post(this.url + 'web/course/view', data, { headers })
  }
  getSubSectionDetail(data) {
    return this.http.post(this.url + 'web/course/get_sub_section', data, { headers })
  }
  getTheme(){
    return this.http.get(this.url + 'web/course/get_theme',{ headers })
  }
  // =====Playlist
  getAllPlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/get_playlist', data, { headers })
  }
  createPlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/create', data, { headers })
  }
  assignPlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/assign_playlist', data, { headers })
  }
  getAllCoursePlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/get_all_playlist_course', data, { headers })
  }
  deletePlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/delete', data, { headers })
  }
  getUsePlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/get_use_course', data, { headers })
  }
  viewDetailAssignPlaylist(data) {
    return this.http.post(this.courseUrl + 'playlist/get_playlist_wise_other', data, { headers })
  }
  viewPlaylistAssigned(data) {
    return this.http.post(this.courseUrl + 'playlist/get_playlist_wise_data', data, { headers })
  }
  getStoreList(data) {
    return this.http.post(this.courseUrl + 'library/store_list', data, { headers })
  }
  addStore(data) {
    return this.http.post(this.courseUrl + 'library/add_library', data, { headers })
  }
  deleteStore(data) {
    return this.http.post(this.courseUrl + 'library/delete', data, { headers })
  }

}
